import { Spinner } from '@/components/ui/spinner';

export default function IntegrationSkeleton() {
  return (
    <div className="flex h-full w-full items-center justify-center py-20">
      <Spinner size="lg" />
    </div>
  );
}
